import { QueryClient } from '@tanstack/react-query'

// Singleton do React Query exportado em módulo próprio para poder ser usado
// FORA de componentes React (ex.: logout() na store zustand de auth, que precisa
// limpar o cache na troca de conta). Antes o client vivia só dentro do main.tsx
// e o logout SPA não tinha como chamar .clear() — o cache (logo/nome da filial,
// empresa) sobrevivia e vazava entre tenants. Ver auth.ts logout().
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 } },
})
